import { template } from "@ember/template-compiler";
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { fn } from '@ember/helper';
import { parseCommaSeparatedStrings } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { toggleSelection } from 'client-portal/utils/clinicianSearch/toggle-selection';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterCheckboxLine from '../filters/filter-checkbox-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './location.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchFacetFiltersLocation extends Component {
    @service
    intl;
    @service
    store;
    @service
    clinicianSearch;
    styles = styles;
    @tracked
    selectedOfficeIds = [];
    @tracked
    officeCountById = new Map();
    @tracked
    officesLoadFailed = false;
    constructor(){
        super(...arguments);
        this.selectedOfficeIds = parseCommaSeparatedStrings(this.clinicianSearch.query.officeIds).map(this.canonicalOfficeId).filter(Boolean);
    }
    get filterOptionsLoadingAriaLabel() {
        return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
    }
    get sortedPracticeOffices() {
        let offices1 = this.store.peekAll('office')?.toArray() ?? [];
        return [
            ...offices1
        ].sort((a1, b1)=>this.officeLabel(a1).localeCompare(this.officeLabel(b1), undefined, {
                sensitivity: 'base'
            }));
    }
    canonicalOfficeId = (id1)=>String(id1 ?? '').trim();
    refreshFacets = async ()=>{
        this.officesLoadFailed = false;
        try {
            let routeParams1 = {
                ...this.clinicianSearch.query.toRouteParams(),
                officeIds: null
            };
            let meta1 = this.clinicianSearch.sendAll.buildFacetsMeta(routeParams1);
            this.officeCountById = new Map((meta1?.facets?.offices ?? []).map((bucket1)=>[
                    String(bucket1.key),
                    bucket1.count
                ]));
        } catch  {
            this.officesLoadFailed = true;
        }
    };
    isOfficeSelected = (id1)=>{
        let sid1 = this.canonicalOfficeId(id1);
        return !!sid1 && this.selectedOfficeIds.includes(sid1);
    };
    docCountForOffice = (office1)=>this.officeCountById.get(this.canonicalOfficeId(office1.id)) ?? 0;
    officeOptionDisabled = (office1)=>facetOptionDisabled(this.docCountForOffice(office1), this.isOfficeSelected(office1.id));
    officeRowTitle = (office1)=>{
        if (!this.officeOptionDisabled(office1)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    officeLabel = (office1)=>{
        let name1 = String(office1?.name ?? '').trim();
        if (name1) {
            return name1;
        }
        let address1 = this.officeAddressLabel(office1);
        if (address1) {
            return address1;
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.officeUnknown', {
            id: office1.id
        });
    };
    officeAddressLabel = (office1)=>{
        let parts1 = [];
        if (office1?.isPublic && office1?.street) {
            parts1.push(String(office1.street).trim());
        }
        let cityState1 = [
            office1?.city,
            office1?.state
        ].map((v1)=>String(v1 ?? '').trim()).filter(Boolean).join(', ');
        let zip1 = String(office1?.formattedZip ?? office1?.zip ?? '').trim();
        let cityStateZip1 = [
            cityState1,
            zip1
        ].filter(Boolean).join(' ');
        if (cityStateZip1) {
            parts1.push(cityStateZip1);
        }
        return parts1.join(', ');
    };
    toggleOffice = (id1, event1)=>{
        let sid1 = this.canonicalOfficeId(id1);
        if (!sid1) {
            return;
        }
        this.selectedOfficeIds = toggleSelection(this.selectedOfficeIds, sid1, event1.target.checked);
    };
    apply = ()=>{
        this.clinicianSearch.query.applyFacetFilter('location', this.selectedOfficeIds);
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template(`
    <RequestClinicianSearchFiltersPanel
      @applyDisabled={{false}}
      @class={{this.styles.component}}
      @facetKey="location"
      @isLoading={{this.clinicianSearch.sendAll.isLoading}}
      @loadingAriaLabel={{this.filterOptionsLoadingAriaLabel}}
      @onApply={{this.apply}}
      @onLoad={{this.refreshFacets}}
      data-test-clinician-search-filter-location-options
    >
      <p class="filter-section-title" id="clinician-search-location-filter-title">{{t
          "booking.clinicianSearch.filters.location"
        }}</p>
      {{#if this.officesLoadFailed}}
        <p class="error" data-test-clinician-search-filter-location-options-error>
          {{t "booking.clinicianSearch.filterDetail.locationsLoadError"}}
        </p>
      {{/if}}
      <div class="body" role="group" aria-labelledby="clinician-search-location-filter-title">
        <ul class="filter-checkbox-list" role="list">
          {{#each this.sortedPracticeOffices as |office|}}
            <RequestClinicianSearchFiltersFilterCheckboxLine
              @kind="office"
              @optionId={{office.id}}
              @docCount={{this.docCountForOffice office}}
              @title={{this.officeRowTitle office}}
              @checked={{this.isOfficeSelected office.id}}
              @disabled={{this.officeOptionDisabled office}}
              @onChange={{fn this.toggleOffice office.id}}
            >
              {{this.officeLabel office}}
            </RequestClinicianSearchFiltersFilterCheckboxLine>
          {{/each}}
        </ul>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
